/**
 * CreditPurchaseSuccess - Page de succès après achat de crédits
 * Redirige vers PaymentSuccessPage unifié
 */
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export default function CreditPurchaseSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');
  const transactionId = searchParams.get('transaction_id');

  useEffect(() => {
    // Rediriger vers la page de succès unifiée
    if (sessionId) {
      const params = new URLSearchParams({
        session_id: sessionId,
        type: 'credits'
      });
      if (transactionId) {
        params.append('transaction_id', transactionId);
      }
      navigate(`/paiement/success?${params.toString()}`, { replace: true });
    } else {
      navigate('/member/dashboard', { replace: true });
    }
  }, [sessionId, transactionId, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-green-500 animate-spin mx-auto mb-4" />
        <p className="text-gray-600">Vérification des crédits...</p>
      </div>
    </div>
  );
}
